<template>
  <div>
    <a-spin :spinning="spinning" tip="Loading...">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a gene name"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        row-id="id"
        size="small"
        ref="xTable"
        :scroll-y="{ enabled: false }"
        :data="tableData_detable"
        align="center"
        header-align="center"
        class="my-sort"
        :row-config="{ isHover: true, isCurrent: true, isHover: true }"
        :sort-config="{
          showIcon: false,
          trigger: all,
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <vxe-column type="expand" width="40">
          <template #content="{ row }">
            <div
              v-if="row.geneList.includes(',')"
              style="
                margin-left: 60px;
                padding: 15px 0px;
                word-break: break-all;
              "
            >
              <span
                v-for="(index, element) in row.geneList.split(',')"
                :key="index"
                :value="element"
              >
                <a-tag
                  v-if="index.startsWith('known-')"
                  style="margin-bottom: 4px"
                >
                  {{ index.replace(/^known-/, "") }}</a-tag
                >
                <a-tag style="margin-bottom: 4px" v-else>
                  {{ index }}
                </a-tag>
                <br v-if="(element + 1) % 8 === 0" />
              </span>
            </div>
            <div
              v-else
              style="
                margin-left: 60px;
                padding: 15px 0px;
                word-wrap: break-word;
              "
            >
              <span
                v-for="(index, element) in row.geneList.split('\n')"
                :key="index"
                :value="element"
              >
                <a-tag
                  v-if="index.startsWith('known-')"
                  style="margin-bottom: 4px"
                >
                  {{ index.replace(/^known-/, "") }}</a-tag
                >
                <a-tag style="margin-bottom: 4px" v-else>
                  {{ index }}
                </a-tag>
                <br v-if="(element + 1) % 8 === 0" />
              </span>
            </div>
          </template>
        </vxe-column>
        <vxe-column
          field="clusterID"
          title="Perturbation cluster ID"
          type="html"
        >
          <template #default="{ row }">
            <a
              @click="goToDetails(row.clusterID, row.datasetID)"
              style="color: blue"
            >
              {{ row.clusterID }}</a
            >
          </template>
        </vxe-column>
        <vxe-column
          field="geneNum"
          title="No. of gene"
          type="html"
          sort-type="number"
          sortable
        >
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
        </vxe-column>
        <vxe-column
          field="complex"
          title="Complex annotation"
          type="html"
        ></vxe-column>
        <vxe-column
          field="pathway"
          title="Pathway annotation"
          type="html"
        ></vxe-column>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[10, 50, 100]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  props: ["choosepathway"],
  data() {
    return {
      //相关性分析
      corModal: false,
      gene1: "",
      gene2: this.$route.query.gene,
      //加载
      spinning: false,
      //num的排序
      sortNUM: "no",
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/clusters/clusters_all.php"
      )
      .then((response) => {
        // this.getdata_detable = response.data;
        this.getdata_detable = response.data.filter(
          (item) => item.datasetID === this.$route.query.datasetId
        );
        this.findList_detable(this.getdata_detable);
        this.spinning = false;
      });
  },

  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        if (column.order === "desc") {
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/clusters/clusters_all.php"
            )
            .then((response) => {
              // this.getdata_detable = response.data;
              this.getdata_detable = response.data.filter(
                (item) => item.datasetID === this.$route.query.datasetId
              );
              this.$refs.xTable.clearSort();
              this.findList_detable(this.getdata_detable);
              this.spinning = false;
            });
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属升序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    goSubpub(value) {
      let routeData = this.$router.resolve({
        name: "pubdatasets",
        query: { datasetId: value },
      });
      window.open(routeData.href, "_blank");
    },
    goToDetails(value) {
      let routeData = this.$router.resolve({
        name: "pcDetails",
        query: { pcID: value },
      });
      window.open(routeData.href, "_blank");
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: this.$route.query.datasetId + "_all_clusters",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename: this.filterName_detable + "_related_clusters",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    handleOk() {
      this.corModal = false;
    },
    handleCancel() {
      this.corModal = false;
    },
    goPerturbgene_detable(value1, value2) {
      let href =
        "http://research.gzsys.org.cn/perturbdb/#/perturbedgenes?gene=" +
        value1 +
        "&datasetId=" +
        value2;
      window.open(href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
      this.$refs.xTable.setAllRowExpand(true); //保证基因列表是展开的
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; // 每次查找都定位到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["clusterID", "annotation", "geneList"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
        this.$refs.xTable.setAllRowExpand(true); //保证基因列表是展开的
      } else {
        this.findList_detable(this.getdata_detable);
        this.$refs.xTable.setAllRowExpand(true); //保证基因列表是展开的
      }
      this.$refs.xTable.setAllRowExpand(true); //保证基因列表是展开的
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
